<div class="wrapper">
  <mat-form-field class="operator" *ngIf="showQueryOperator" appearance="outline">
    <mat-select [(ngModel)]="queryOperator" (selectionChange)="onOperatorChange($event)">
      <mat-option *ngFor="let queryOperator of queryOperatorValues" [value]="queryOperator">
        {{queryOperator}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="search-area" appearance="outline">
    <input matInput type="text"
      [placeholder]="placeholder || ''"
      [attr.disabled]="isDisabled ? true : null"
      (keyup)="onKeyup($event.target['value'])"
      (blur)="onBlur()"
      [value]="searchValue">
  </mat-form-field>
  <mat-icon *ngIf="showTipIcon" svgIcon="info-circle"
            class="icon info-icon tooltip-content"
            matTooltipClass="info-tooltip-content"
            matTooltip="Quick Tip
                  
Operator AND is always connecting 2 search entries and giving the results which are fulfilling both.
The Operator OR serves as a „bracket“, divider between different search entries. Search results are displaying all the results which are fulfilling the first part of the command (BEFORE OR) and all the search results fulfilling the second part of the command (AFTER OR).
Scheme: ( AND ▲ AND ◉ ) OR ( ◯ AND ▇ )
If multiple entries are chosen in drop-down field, they are connected with an OR operator."
            matTooltipPosition="below"
            matTooltipShowDelay="100"></mat-icon>
</div>